"use client";

import React, { useEffect, useRef } from "react";
import { motion, useAnimate } from "framer-motion";
import { cn } from "../../Lib/utils";

export const Button = ({ className, children, isLoading, ...props }) => {
  const [scope, animate] = useAnimate();
  const prevLoading = useRef(false);

  useEffect(() => {
    if (isLoading && !prevLoading.current) {
      animate(".loader", {
        scale: 1,
        opacity: 1,
        display: "inline-block",
      });

      animate(".check", {
        scale: 0,
        opacity: 0,
        display: "none",
      });
    } else if (!isLoading && prevLoading.current) {
      animate(".loader", {
        scale: 0,
        opacity: 0,
        display: "none",
      });

      animate(".check", {
        scale: 1,
        opacity: 1,
        display: "inline-block",
      }).then(() => {
        setTimeout(() => {
          animate(".check", {
            scale: 0,
            opacity: 0,
            display: "none",
          });
        }, 2000);
      });
    }

    prevLoading.current = isLoading;
  }, [isLoading, animate]);

  return (
    <motion.button
      ref={scope}
      disabled={isLoading}
      className={cn(
        "group/btn relative flex h-10 w-40 ssm:w-48 items-center justify-center rounded-md bg-gradient-to-br from-black to-neutral-600 text-sm font-medium text-white shadow-[0px_1px_0px_0px_#ffffff40_inset,0px_-1px_0px_0px_#ffffff40_inset] disabled:opacity-70",
        className,
      )}
      {...props}
    >
      <span className="relative flex w-full items-center justify-center">
        <Loader isLoading={isLoading} />
        <CheckIcon />

        <span
          className={cn(
            "transition-opacity text-md ssm:text-lg font-semibold font-Mtavruli duration-200",
            isLoading ? "opacity-50" : "opacity-100",
          )}
        >
          {children}
        </span>
      </span>
    </motion.button>
  );
};

const Loader = ({ isLoading }) => (
  <motion.svg
    className="loader absolute left-4 ssm:left-6 -translate-y-1/2 text-white"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    initial={{ scale: 0, opacity: 0, display: "none" }}
    animate={{
      rotate: isLoading ? [0, 360] : 0,
      scale: isLoading ? 1 : 0,
      opacity: isLoading ? 1 : 0,
      display: isLoading ? "inline-block" : "none",
    }}
    transition={{
      rotate: {
        duration: 0.8,
        repeat: Infinity,
        ease: "linear",
      },
    }}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M12 3a9 9 0 1 0 9 9" />
  </motion.svg>
);

const CheckIcon = () => (
  <motion.svg
    className="check absolute left-4 ssm:left-6 -translate-y-1/2 text-white"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    initial={{ scale: 0, opacity: 0, display: "none" }}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
    <path d="M9 12l2 2l4 -4" />
  </motion.svg>
);
